import { render } from "./GridPembayaranPiutangDetail.vue?vue&type=template&id=2b1bbaa4"
import script from "./GridPembayaranPiutangDetail.vue?vue&type=script&lang=js"
export * from "./GridPembayaranPiutangDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__